function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  className: "blur_svg__Thumbnail_Pro blur_svg__Gallery blur_svg__Animations_Hover blur_svg__Effect_Blur",
  filter: "url(#blur_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#80B1FF",
  d: "M25 25h22c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H25c-1.1 0-2-.9-2-2V27c0-1.1.9-2 2-2z",
  className: "blur_svg__illus-clr-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EBF2FF",
  d: "M43.57 40h-15c-.81 0-1.28-.85-.81-1.47l3.17-4.14c.36-.47 1.08-.52 1.51-.12l2.49 2.33 2.89-4.17c.38-.55 1.21-.58 1.63-.06l4.91 6.07c.51.63.04 1.56-.79 1.56z",
  className: "blur_svg__illus-clr-3"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "blur_svg__a",
  width: 75,
  height: 75,
  x: -1.5,
  y: -1.5,
  className: "blur_svg__filter0_f_2278_175391",
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2278_175391",
  stdDeviation: 0.75
})));

function SvgBlur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='72' height='72' fill='none' viewBox='0 0 72 72'%3E %3Cg class='Thumbnail_Pro Gallery Animations_Hover Effect_Blur' filter='url(%23a)'%3E %3Cpath fill='%2380B1FF' d='M25 25h22c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H25c-1.1 0-2-.9-2-2V27c0-1.1.9-2 2-2Z' class='illus-clr-1'/%3E %3Cpath fill='%23EBF2FF' d='M43.57 40h-15c-.81 0-1.28-.85-.81-1.47l3.17-4.14c.36-.47 1.08-.52 1.51-.12l2.49 2.33 2.89-4.17c.38-.55 1.21-.58 1.63-.06l4.91 6.07c.51.63.04 1.56-.79 1.56Z' class='illus-clr-3'/%3E %3C/g%3E %3Cdefs%3E %3Cfilter id='a' width='75' height='75' x='-1.5' y='-1.5' class='filter0_f_2278_175391' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3E %3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E %3CfeBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E %3CfeGaussianBlur result='effect1_foregroundBlur_2278_175391' stdDeviation='.75'/%3E %3C/filter%3E %3C/defs%3E %3C/svg%3E";
export { SvgBlur as ReactComponent };